import React, { useState } from 'react';
import useAuthStore from '../store/useAuthStore';
import { useNavigate, Link } from 'react-router-dom';
import OmniIcon from '../components/icons/OmniIcon';

const DesktopLogin = () => {
    const { signInWithGoogle, loginWithEmail, registerWithEmail, error } = useAuthStore();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showEmailForm, setShowEmailForm] = useState(false);

    const handleGoogleLogin = async () => {
        try {
            await signInWithGoogle();
            navigate('/');
        } catch (err) {
            // Error mapped in store
        }
    };

    const handleEmailLogin = async (e) => {
        e.preventDefault();
        try {
            await loginWithEmail(email, password);
            navigate('/');
        } catch (err) { }
    };

    const handleEmailRegister = async () => {
        try {
            await registerWithEmail(email, password);
            navigate('/');
        } catch (err) { }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[var(--bg-main)] text-[var(--text-main)] p-6 selection:bg-[var(--accent-primary)]/10">
            <div className="w-full max-w-sm p-10 space-y-8 bg-[var(--bg-secondary)] border border-[var(--border-subtle)] rounded-2xl shadow-xl">

                {/* Header */}
                <div className="text-center space-y-1">
                    <Link 
                        to="/" 
                        className="inline-flex items-center gap-2 group transition-opacity hover:opacity-80"
                    >
                        <OmniIcon className="w-8 h-8 text-[var(--text-main)] transition-transform group-hover:scale-110" />
                        <h1 className="text-2xl font-bold tracking-tighter text-[var(--text-main)] transition-all">
                            Omni
                        </h1>
                    </Link>
                    <p className="text-sm text-[var(--text-muted)] font-medium tracking-wide">
                        Desktop Bridge
                    </p>
                </div>

                {/* Error Banner */}
                {error && (
                    <div className="p-3 text-sm font-medium text-red-400 bg-red-400/10 border border-red-400/20 rounded-lg">
                        {error}
                    </div>
                )}

                <div className="space-y-4 relative z-10">
                    <button
                        onClick={handleGoogleLogin}
                        className="w-full flex items-center justify-center gap-3 px-4 py-2.5 text-sm font-semibold text-black bg-white rounded-xl hover:bg-stone-100 transition-all duration-200"
                    >
                        <svg className="w-5 h-5" viewBox="0 0 24 24">
                            <path
                                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                fill="#4285F4"
                            />
                            <path
                                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                fill="#34A853"
                            />
                            <path
                                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                fill="#FBBC05"
                            />
                            <path
                                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                fill="#EA4335"
                            />
                        </svg>
                        Continue with Google
                    </button>

                    <div className="relative py-2">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-[var(--border-subtle)]"></div>
                        </div>
                        <div className="relative flex justify-center text-xs">
                            <span className="px-2 text-[var(--text-muted)] bg-[var(--bg-secondary)] border overflow-hidden rounded-full border-[var(--border-subtle)]">OR</span>
                        </div>
                    </div>

                    {!showEmailForm ? (
                        <button
                            onClick={() => setShowEmailForm(true)}
                            className="w-full px-4 py-2.5 text-sm font-semibold text-[var(--text-main)] bg-transparent border border-[var(--border-strong)] rounded-xl hover:bg-stone-800/30 transition-all duration-200"
                        >
                            Sign in with Email
                        </button>
                    ) : (
                        <form onSubmit={handleEmailLogin} className="space-y-4 animate-in fade-in slide-in-from-top-2 duration-300">
                                <div className="space-y-3">
                                    <div>
                                        <label className="sr-only" htmlFor="email">Email</label>
                                        <input
                                            id="email"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="name@example.com"
                                                                                        className="w-full px-4 py-2.5 bg-[#1E1D1C] border border-[var(--border-subtle)] rounded-xl outline-none focus:outline-none focus:border-[rgba(var(--accent-primary-rgb),0.8)] transition-all duration-200 text-sm placeholder:text-[var(--text-dim)]"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="sr-only" htmlFor="password">Password</label>
                                        <input
                                            id="password"
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="••••••••"
                                            className="w-full px-4 py-2.5 bg-[#1E1D1C] border border-[var(--border-subtle)] rounded-xl outline-none focus:outline-none focus:border-[rgba(var(--accent-primary-rgb),0.8)] transition-all duration-200 text-sm placeholder:text-[var(--text-dim)]"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="space-y-3 pt-2">
                                    <button
                                        type="submit"
                                        className="w-full px-4 py-2.5 text-sm font-semibold text-[var(--bg-main)] bg-[var(--accent-primary)] rounded-xl hover:bg-[var(--accent-hover)] transition-all duration-200"
                                    >
                                        Sign In
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleEmailRegister}
                                        className="w-full px-4 py-2 text-sm font-medium text-[var(--text-dim)] hover:text-[var(--text-muted)] transition-colors"
                                    >
                                        Create new account
                                    </button>
                                </div>
                        </form>
                    )}
                </div>
            </div>

            {/* Footer */}
            <p className="mt-8 text-[11px] font-bold text-[var(--text-dim)] uppercase tracking-[0.2em] opacity-40">
                Securely connects to your Cloud account
            </p>
        </div>
    );
};

export default DesktopLogin;
